/* eslint-disable react/no-danger */
import React, { memo, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import GroupSenderMC from './GroupSenderMC';
import MessageStatusMC from './MessageStatusMC';
import QuickReplyOptionsMC from './QuickReplyOptionsMC';
import ImageMC from '../../../components/ImageMC';
import VideoMC from '../../../components/VideoMC';
import DocumentMC from './DocumentMC';

const QuickReplyMessageMC = memo(({ conversation, message, onClick }) => {
  const { t } = useTranslation('InboxMC');

  // Memoized message text
  const messageText = useMemo(() => message.messageText || '', [message.messageText]);
  const contentType = useMemo(() => message.optionsList?.content?.type || null, [message.optionsList]);

  // Refactor: renderizado de media separado por tipo para mejor mantenibilidad y performance
  const renderImage = useCallback(() => (
    <div className="tw-mb-5 tw-bg-gray-50 tw-rounded tw-p-2 tw-flex tw-flex-col tw-items-center">
      <GroupSenderMC message={message} />
      <ImageMC
        platform={conversation.platform}
        data={message}
        onClick={onClick}
        className="tw-block tw-w-full tw-max-w-xs tw-rounded tw-cursor-pointer tw-shadow"
      />
    </div>
  ), [onClick, message, conversation.platform]);

  const renderFile = useCallback(() => (
    <div className="tw-mb-5 tw-flex tw-items-center tw-gap-2">
      <DocumentMC
        data={message}
        fileName={message.optionsList.content.filename || t('file.download')}
        className="tw-flex tw-items-center tw-font-medium tw-text-sm hover:tw-underline"
        iconName="file-download-outline"
        iconClassName="tw-mr-1"
      />
    </div>
  ), [message, t]);

  const renderVideo = useCallback(() => (
    <div className="tw-mb-5 tw-bg-gray-50 tw-rounded tw-p-2 tw-flex tw-flex-col tw-items-center">
      <VideoMC
        platform={conversation.platform}
        data={message}
        className="tw-block tw-rounded tw-shadow tw-w-[320px] tw-h-[240px]"
      />
    </div>
  ), [conversation.platform, message]);

  // Memoiza el renderizado del caption multimedia
  const renderCaption = useMemo(() => {
    if (contentType === 'image') return renderImage();
    if (contentType === 'file') return renderFile();
    if (contentType === 'video') return renderVideo();
    return null;
  }, [contentType, renderImage, renderFile, renderVideo]);

  // Render principal optimizado
  return (
    <div className="tw-wrapper">
      {renderCaption}
      <div className="tw-text-pre-line tw-text-sm tw-mb-2">
        <div dangerouslySetInnerHTML={{ __html: messageText }} />
        <MessageStatusMC message={message} platform={conversation.platform} />
      </div>
      <div className="tw-text-pre-line tw-text-sm">
        <QuickReplyOptionsMC options={message.optionsList?.options || message.optionsList} />
      </div>
    </div>
  );
});

QuickReplyMessageMC.displayName = 'QuickReplyMessageMC';

export default QuickReplyMessageMC;
